var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilterList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49866 16.9987C4.08038 16.9987 0.498657 13.417 0.498657 8.9987C0.498657 4.58042 4.08038 0.998703 8.49866 0.998703C12.9169 0.998703 16.4987 4.58042 16.4987 8.9987C16.4987 13.417 12.9169 16.9987 8.49866 16.9987ZM8.49996 16C12.366 16 15.5 12.866 15.5 9C15.5 5.13401 12.366 2 8.49996 2C4.63396 2 1.49996 5.13401 1.49996 9C1.49996 12.866 4.63396 16 8.49996 16ZM3.99996 6H13C13.2761 6 13.5 6.22386 13.5 6.5C13.5 6.77614 13.2761 7 13 7H3.99996C3.72381 7 3.49996 6.77614 3.49996 6.5C3.49996 6.22386 3.72381 6 3.99996 6ZM5.99996 9H11C11.2761 9 11.5 9.22386 11.5 9.5C11.5 9.77614 11.2761 10 11 10H5.99996C5.72381 10 5.49996 9.77614 5.49996 9.5C5.49996 9.22386 5.72381 9 5.99996 9ZM7.99996 12H8.99996C9.2761 12 9.49996 12.2239 9.49996 12.5C9.49996 12.7761 9.2761 13 8.99996 13H7.99996C7.72381 13 7.49996 12.7761 7.49996 12.5C7.49996 12.2239 7.72381 12 7.99996 12Z",
    fill: "#343741"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-list.a06fbf6c.svg";
export { ForwardRef as ReactComponent };